import { Button } from '@zep-us/zus';
import { BoltFillColorVioletIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { openAiBuilderPaywallModal } from '../utils/openAiBuilderPaywallModal';

/**
 * 무료 AI 채팅 횟수 소진 인트로 오버레이 — 빌드에서 AI 채팅을 시작할 수 없는 상태일 때
 * 메시지 영역 전체를 덮어 업그레이드 후 AI 퀴즈 생성을 이어갈 수 있음을 안내한다.
 * 시안: Figma (39062:35431) — violet 8% + backdrop-blur 배경, gradient/violet-blue 2px
 * 보더, 세로 중앙정렬 ⚡ + 제목/설명 + "플랜 가격 확인하기" gradient 버튼.
 * 버튼 기본 동작은 채팅 컨텍스트를 유지한 채 기존 paywall(UpsellingModal)을 오버레이로 연다.
 *
 * 배경이 반투명(violet 8%)이라 padding-box 그라디언트 보더가 비쳐서, mask 기법으로
 * 테두리 링만 그라디언트로 그린다.
 */
export const AiBuilderUsageExhaustedIntro = ({
  onCheckPlans = openAiBuilderPaywallModal,
  usageLimit = 10
}: {
  onCheckPlans?: () => void;
  usageLimit?: number;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const title = usageLimit > 0 ? t('build:aiBuilderChat.usage.exhaustedTitleWithLimit', {
    usageLimit
  }) : t('build:aiBuilderChat.usage.exhaustedTitle');
  return <div className="relative flex size-full flex-col items-center justify-center gap-sm overflow-hidden rounded-md bg-opacity-violet-2 px-2xl pb-xl backdrop-blur-[4px]" data-sentry-component="AiBuilderUsageExhaustedIntro" data-sentry-source-file="AiBuilderUsageExhaustedIntro.tsx">
      {/* gradient/violet-blue 2px 보더 링 (안쪽은 투명 유지) */}
      <div aria-hidden className="pointer-events-none absolute inset-0 rounded-md" style={{
      padding: '2px',
      background: 'linear-gradient(90deg, #8478ff, #3da9ff)',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude'
    }} />
      <div className="flex flex-col items-center gap-sm">
        <BoltFillColorVioletIcon size="xl" data-sentry-element="BoltFillColorVioletIcon" data-sentry-source-file="AiBuilderUsageExhaustedIntro.tsx" />
        <div className="flex flex-col items-center gap-3xs text-center">
          <p className="w-full text-heading-md-bold text-default">{title}</p>
          <p className="w-full text-body-md-semibold text-neutral">
            {t('build:aiBuilderChat.usage.exhaustedDescription')}
          </p>
        </div>
      </div>
      <Button type="button" variant="contained" intent="gradient" size="lg" rounded="full" className="h-12 w-[300px]" onClick={onCheckPlans} data-sentry-element="Button" data-sentry-source-file="AiBuilderUsageExhaustedIntro.tsx">
        {t('build:aiBuilderChat.usage.checkPlans')}
      </Button>
    </div>;
};